import {
  SET_EXPERIMENT_CYBER,
  CLEAN_EXPERIMENTS,
  SET_EXPERTIMENT_TRIPS_DISCOUNT,
  SET_EXPERIMENT_BENEFITS,
  SET_EXPERIMENT_MAINTENANCE_SCREEN,
} from "../types/experiment";

export const setExperimentCyber = (value) => async (dispatch) => {
  try {
    dispatch({ type: SET_EXPERIMENT_CYBER, payload: value });
  } catch (err) {
    window.location.reload();
  }
};

export const setExperimentBenefits = (value) => async (dispatch) => {
  try {
    dispatch({ type: SET_EXPERIMENT_BENEFITS, payload: value });
  } catch (err) {
    window.location.reload();
  }
};

export const cleanExperiments = () => async (dispatch) => {
  try {
    dispatch({ type: CLEAN_EXPERIMENTS });
  } catch (err) {
    window.location.reload();
  }
};

export const setExperimentsTripsDiscount = (value) => async (dispatch) => {
  try {
    dispatch({ type: SET_EXPERTIMENT_TRIPS_DISCOUNT, payload: value });
  } catch (err) {
    window.location.reload();
  }
};

export const setExperimentsMaintenanceScreen = (value) => async (dispatch) => {
  try {
    dispatch({ type: SET_EXPERIMENT_MAINTENANCE_SCREEN, payload: value });
  } catch (err) {
    window.location.reload();
  }
};
